module.exports = __webpack_public_path__ + "static/Truck6-b2a249371037c048a60d6114e39fe70b.png";